import { apiEndpoints } from "../apiConfig";
import axiosInstance from "../axiosInstance";

const addmangerApi = {

  addmanger: (payload) => axiosInstance.post(apiEndpoints.addManager, payload),
  deactivateManager: (payloadId) => axiosInstance.post(apiEndpoints.deactivateManager, payloadId),
  getHistory: () => axiosInstance.get(apiEndpoints.getHistory),
  addexcutive: (payload) => axiosInstance.post(apiEndpoints.addExcutive, payload),
  getexecutivelist: (payload) => axiosInstance.post(apiEndpoints.getExecutiveList, payload),
  deactivateExecutive: (payload) => axiosInstance.post(apiEndpoints.deactivateExcutive, payload),
  getManagerList: (payload) => axiosInstance.post(apiEndpoints.getManagerList, payload),
  updateManager: (payload) => axiosInstance.post(apiEndpoints.updateManager, payload),
};

export default addmangerApi;
